// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mSCE","col":"styles_col__1G2mX","actions":"styles_actions__2s0zp","conflict":"styles_conflict__3mafw"};